import { yup } from 'utils';

export default yup.object().shape({
  facility_tel: yup.string().matches(/^(([0-9]{1,}(-){0,}){1,}([0-9]){1,})$/, '数字と記号のみ入力可能 -'),
  facility_name: yup.string().required('医療機関名を入力して下さい'),
  cpap_unit_price: yup.string().matches(/^([0-9]+)$/, '数字のみ入力可能'),
  cpap_unit_sp_price: yup.string().matches(/^([0-9]+)$/, '数字のみ入力可能'),
  psg_unit_price: yup.string().matches(/^([0-9]+)$/, '数字のみ入力可能'),
  simplicity_unit_price: yup.string().matches(/^([0-9]+)$/, '数字のみ入力可能'),
});
